import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { Card, Typography } from '@mui/material';

export default function RevenuePieChart({ data }) {
  const COLORS = ['#3B82F6', '#22C55E', '#F59E0B', '#EF4444'];

  return (
    <Card
      sx={{
        p: 3,
        borderRadius: '20px',
        boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
        // background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)',
      }}
    >
      <Typography
        variant="h6"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        Revenue Breakdown
      </Typography>

      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data.filter((entry) => entry.count > 0)}
            dataKey="amount"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={120}
            innerRadius={60}
            paddingAngle={4}
            isAnimationActive={true}
            animationDuration={1000}
            labelLine={false}
            label={({ name, amount }) => `${name} (USD ${amount?.toFixed(2)})`}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
                stroke="white"
                strokeWidth={2}
                style={{ cursor: 'pointer' }}
              />
            ))}
          </Pie>

          <Tooltip
            formatter={(value, name, entry) => [
              `Amount: USD ${entry.payload.amount?.toFixed(2)} | Count: ${entry.payload.count}`,
              entry.payload.name,
            ]}
            contentStyle={{
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
              border: 'none',
              fontSize: '0.9rem',
            }}
          />

          <Legend verticalAlign="bottom" height={36} />
        </PieChart>
      </ResponsiveContainer>
    </Card>
  );
}
